import useFeedbackStore from "@/shared/model/feedbackStore";
import type { AlertDialogPayload } from "@/shared/model/feedbackStore";
import useLoadingStore from "@/shared/model/loadingStore";

export function useAlertDialog() {
  const openAlertDialog = useFeedbackStore((s) => s.openAlertDialog);
  const closeAlertDialog = useFeedbackStore((s) => s.closeAlertDialog);
  return {
    open: (payload: AlertDialogPayload) => openAlertDialog(payload),
    close: closeAlertDialog,
  };
}

export function useToast() {
  const show = useFeedbackStore((s) => s.showToast);
  const hide = useFeedbackStore((s) => s.hideToast);
  return { show, hide };
}

export function useLoadingOverlay() {
  const setLoading = useLoadingStore((s) => s.setLoading);
  return {
    show: (message?: string) => setLoading(true, message),
    hide: () => setLoading(false),
  };
}
